



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import SimpleDialog from '@c/SimpleDialog.vue';
import {NodeData} from '@/system/nodes/interfaces';

@Component({components: {SimpleDialog}})
export default class NodesTreeRemoveDialog extends Vue {
  @Prop({required: true})
  node!: NodeData | null;

  get title() {
    return 'Удаление узла ' + this.node?.name;
  }

  dialog = false;
  btnIndex: number | null = null;
  btnActiveState = false;

  @Watch('dialog')
  onDialog(value: boolean) {
    if (!value) this.updateBtnState();
  }

  onSubmit() {
    this.dialog = false;
    this.updateBtnState();
    this.$emit('submitForm', this.node);
  }

  onClickCancel() {
    this.dialog = false;
  }

  updateBtnState() {
    this.btnActiveState = this.dialog;
    this.btnIndex = this.dialog ? 0 : null;
  }
}
